import { useMemo } from 'react'
import { z } from 'zod'
import { useExperimentVariables } from '@mc/experiments-react'
import { reportError } from '@mc/next-newrelic'
import { COHORT_URGENCY_FLAG } from './constants'

const FooterSchema = z.object({
  headline: z.string().min(1),
  subline: z.string().optional(),
})

export type CohortUrgencyCopy = {
  footer?: z.infer<typeof FooterSchema>
}

const parseKey = <T>(
  key: string,
  schema: z.ZodType<T>,
  value: unknown,
): T | undefined => {
  if (value === undefined) return undefined

  const parsed = schema.safeParse(value)
  if (parsed.success) return parsed.data

  reportError(parsed.error, {
    message: 'Invalid cohort urgency copy',
    flag: COHORT_URGENCY_FLAG,
    key,
    value: JSON.stringify(value),
  })
  return undefined
}

export const useCohortUrgencyCopy = (): CohortUrgencyCopy => {
  const variables =
    useExperimentVariables<Record<string, unknown>>(COHORT_URGENCY_FLAG)

  return useMemo(
    () => ({ footer: parseKey('footer', FooterSchema, variables?.footer) }),
    [variables],
  )
}
